import { defineStore } from "pinia";
import { watch } from "vue";
import { useTea } from "../lib/tea";
import { matchMaybe } from "../lib/maybe";
import { readStringPref, writeStringPref } from "../lib/localPrefs";
import {
  clampSidebarWidth,
  DEFAULT_SIDEBAR_WIDTH,
  updateSidebarWidths,
} from "./useSidebarWidthsStore.update";

export const useSidebarWidthsStore = defineStore("sidebarWidths", () => {
  const readWidth = (key: "leftSidebarWidth" | "rightSidebarWidth"): number =>
    matchMaybe(readStringPref(key), {
      nothing: () => DEFAULT_SIDEBAR_WIDTH,
      just: (value) => clampSidebarWidth(Number(value)),
    });
  const { model, dispatch } = useTea(
    {
      left: readWidth("leftSidebarWidth"),
      right: readWidth("rightSidebarWidth"),
    },
    updateSidebarWidths,
  );
  watch(
    () => model.value.left,
    (width) => writeStringPref("leftSidebarWidth", String(width)),
  );
  watch(
    () => model.value.right,
    (width) => writeStringPref("rightSidebarWidth", String(width)),
  );
  return { widths: model, dispatch };
});
